import { useEntityPage } from "../useEntityPage";
import {
  formatAutomationCountValue,
  formatAutomationRateValue,
} from "./automationFormat";

/** One of the automation's sending totals, read with the record, under its label. */
export function AutomationStatistic({
  statistic,
  label,
}: {
  label: string;
  statistic: "emailssent" | "openrate" | "clickrate" | "clickstoopenrate";
}) {
  const { record } = useEntityPage();
  const format =
    statistic === "emailssent" ? formatAutomationCountValue : formatAutomationRateValue;

  return (
    <div className="text-center">
      <div className="field-value__label form-label">{label}</div>
      <p className="fs-3 fw-semibold mb-0">{format(record?.[statistic]) || "-"}</p>
    </div>
  );
}

export default AutomationStatistic;
